module.exports = __webpack_public_path__ + "media/images/ir/common/bg_pagetitle-a1636ecbac734348e99f9e77cc8b0a9c.png";